module.exports = __webpack_public_path__ + "80de08c8938525cc6b0606cb3b018b99.png";